import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './loginThunk';
import { decryptUserInfo } from '../../SharedFiles/decryption/Decryption';

const initialState = {
  user: null,                                           // Stores the user data when logged in
  isAuthenticated: false,                               // Stores whether the user is authenticated or not
  loading: false,                                       // Tracks if the login API call is in progress
  error: null,
  CATEGORY: null                                        // Tracks any error message if the login fails
};

// Create the slice with reducers and extra reducers for async actions
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      sessionStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('cartItems');
      sessionStorage.removeItem('userCate');
      sessionStorage.removeItem('itemGroup');
      sessionStorage.removeItem('itemGroupFlag');
      sessionStorage.removeItem('activeIcon');
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle pending state when login is requested
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // Handle fulfilled state when login is successful
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;                // Set user data
        state.isAuthenticated = true;
        const user = decryptUserInfo(action.payload);
        state.CATEGORY = user[0]?.CATEGORY;
        sessionStorage.setItem('user', JSON.stringify(action.payload));
        sessionStorage.setItem('userCate', JSON.stringify(user[0]?.CATEGORY));
        sessionStorage.setItem('isAuthenticated', true);
      })

      // Handle rejected state when login fails
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.payload || action.error.message;            // Store error message
      });
  },
});

export const { logout } = loginSlice.actions;                            // Export logout action for clearing state
export default loginSlice.reducer;                                       // Export the reducer to be used in the store
